export function NoResultsFound() {
  return (
    <div className="p-8 text-center">
      <h1 className="font-medium">No results found</h1>
      <p className="py-1 text-fg-subtle last-of-type:pb-3">Please change your filters or try another search.</p>
    </div>
  )
}
